


















































import { RouterNames } from "@/router/routernames";
import { lecturas_codigo_barras } from "@/shared/dtos/lecturas_codigo_barras";
import lecturas_codigo_barrasModule from "@/store/modules/lecturas_codigo_barras-module";
import ocultarcamposModule from "@/store/modules/ocultarcampos-module";
import productoModule from "@/store/modules/producto-module";
import { Component, Vue } from "vue-property-decorator";
import { ProcessoNums, getTexto } from "../procesos/ProcessoNums";
import ProductoEscaneado from "./prodcuto-escaneado.vue";
@Component({
  components: {
    ProductoEscaneado,
  },
})
export default class ReceptorCodigos extends Vue {
  public bar_code: lecturas_codigo_barras = new lecturas_codigo_barras();

  private intervalId: any = null;
  public BarCode: string = "";
  public ALERTA: string = "";
  public Show_loading: boolean = true;
  public producto: any = null;
  public precio_venta = 0;

  async created() {
    await productoModule.getproductos();
    await lecturas_codigo_barrasModule.getlecturas_codigo_barras_last();
    this.bar_code = new lecturas_codigo_barras(
      lecturas_codigo_barrasModule.lecturas_codigo_barras
    );

    this.iniciarLectura();

    /* setTimeout(() => {
      this.onScan("LPNIC116470296");
    }, 1000);*/
  }

  onScan(BarCode: string) {
    // handle the message here :)
    if (BarCode.toLowerCase() === this.BarCode!.toLowerCase()) {
      return;
    }
    this.Show_loading = true;
    this.BarCode = BarCode;
    this.Show_loading = false;
    this.emitir();

    /* // Buscar el producto escaneado
    this.producto = productoModule.productos.find(
      (x) => x.lpn.toLowerCase() === this.BarCode!.toLowerCase()
    );
    this.producto.precio_venta =
      Math.round(
        (this.producto.total_retail ? this.producto.total_retail * 0.5 : 0) *
          100
      ) /
        100 +
      " €";
    this.producto.estado = getTexto(this.producto.estado);

    if (this.producto) {
      this.ALERTA = "";
    } else {
      //alert("Producto no encontrado.");
      this.ALERTA = "Producto no encontrado.";
    }*/
  }

  iniciarLectura(): void {
    // Comenzar un intervalo que ejecuta la lectura cada segundo
    this.intervalId = setInterval(() => {
      this.leerCodigoBarras();
    }, 1000); // 1000 ms = 1 segundo
  }

  detenerLectura(): void {
    // Detener el intervalo si está activo
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  private async leerCodigoBarras() {
    await lecturas_codigo_barrasModule.getlecturas_codigo_barras_last();
    if (
      this.bar_code.id !==
      lecturas_codigo_barrasModule.lecturas_codigo_barras.id
    ) {
      this.onScan(
        lecturas_codigo_barrasModule.lecturas_codigo_barras.referencia
      );
      this.bar_code = new lecturas_codigo_barras(
        lecturas_codigo_barrasModule.lecturas_codigo_barras
      );
    }
  }
  get mostrarCamposCoste() {
    return ocultarcamposModule.mostrar_campos_coste;
  }
  emitir() {
    this.emitirPitido(200, 140, "square");
  }

  emitirPitido(
    duracion: number = 500,
    frecuencia: number = 440,
    tipo: OscillatorType = "sine"
  ): void {
    // Crear el contexto de audio
    const audioContext = new (window.AudioContext ||
      (window as any).webkitAudioContext)();

    // Crear un oscilador
    const oscillator = audioContext.createOscillator();

    // Configurar la frecuencia y el tipo de onda del oscilador
    oscillator.frequency.setValueAtTime(frecuencia, audioContext.currentTime);
    oscillator.type = tipo;

    // Conectar el oscilador al destino (los altavoces)
    oscillator.connect(audioContext.destination);

    // Iniciar el oscilador
    oscillator.start();

    // Detener el oscilador después de la duración especificada
    setTimeout(() => {
      oscillator.stop();
      audioContext.close();
    }, duracion);
  }
}
